/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var pli = require("../core");
var keys = require("./keys");

if (require("targetenv").isBrowser) {
    pli.dialog = require("./Dialog");
    pli.forms = require("./Forms");
    pli.keys = new keys.PliKeys(keys.defaultConnector);
    pli.menu = require("./Menu");
    pli.simpleDialogRegistry = require("./SimpleDialogRegistry");

    var setDefaultSignInHandler = require("../core/call").setDefaultSignInHandler;
    var createSignInHandler = pli.config.useLegacySignInHandler
        ? require("../forms-signin").createLegacySignInHandler
        : require("../forms-signin").createSignInHandler;

    setDefaultSignInHandler(createSignInHandler(pli.forms.registry));
}

module.exports = pli;




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms/index.js
// module id = 380
// module chunks = 49